import React, { useEffect, useReducer, useState } from "react"
import { ServerRequestProtected } from "../../../../utils/ServerDataRequest"
import NotificationHandler from "../../../../utils/NotificationHandler"
import { enumUtil } from "../../../../utils/Enum"
import Loader from "../../../shared/Loader/Loader"
import AddNewInsuranceTypeCode from "./AddNewInsuranceTypeCode"
import SearchHeader from "../../Shared/SearchHeader"
import Card from "../../Shared/Card"
import Table from "../../Shared/Table"
import GridColumnHeader from "../../Shared/GridColumnHeader"
import handleCopyText from "../../../shared/CopyData"
import isNull from "../../../../utils/NullChecking"
import { Settings } from "@mui/icons-material"
import { connect } from "react-redux"
import MasterList from "../../Shared/MasterList"
import usePagination from "../../../../customhooks/usePagination"
import { FindSecondChild } from "../../../../utils/FindMenuOption"
const InsuranceTypeCode = (props) => {
    const API_URL = enumUtil.controller.General
    const { type, Settings } = { ...props }
    const { paginationSection, PerPage, PageNo, TotalPages, handlePageClick, PreviousPage, NextPage, handleFingByCreteria, setTotalPages, handleSelectData } = usePagination(Settings.PaginationDefaultRows);
    let IsEditAllowed = FindSecondChild('Setup', 'Insurance', 'Insurance Type')?.IsAdd

    const [isOpenInsuranceType, setisOpenInsuranceType] = useState(false)
    const [InsuranceTypeData, setInsuranceTypeData] = useState([]);
    const [InsuranceTypeCode, setInsuranceTypeCode] = useState();
    const [searchParam, setSearchParam] = useState();
    const [EnterParam, setEnterParam] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [isClose, setIsClose] = useState();
    const [show, setShow] = useState(false);
    const [totalCounts, setTotalCounts] = useState(false);
    const [copiedText, setCopiedText] = useState({});
    const [isOpenMasterList, setisOpenMasterList] = useState(false)

    const searchButton = {
        AddNew: true,
        Excel: false,
        PDF: false,
        Delete: false,
        Filter: false,
        View: false,
        masterListButton: true
    }

    ////////====GridColumnHeader=========//////////
    const [gridHeader, handleGridHeader] = useReducer((prev, next) => {
        return { ...prev, ...next }
    }, { defaultData: '', activeSortIcon: '' })
    //////////////////////////////////////////////
    //For Pagination
    // const [PerPage, setPerPage] = useState(Settings?.PaginationDefaultRows);
    // const [PageNo, setPageNo] = useState(1);
    // const [TotalPages, setTotalPages] = useState();
    const [searchParamType, setSearchparamType] = useState("");
    // const handlePageClick = (page) => { setPageNo(page); }
    // const PreviousPage = () => { if (PageNo > 1) setPageNo(PageNo - 1); }
    // const NextPage = () => { if (PageNo < TotalPages) setPageNo(PageNo + 1); }
    // const handleFingByCreteria = (e) => {
    //     setPerPage(e.target.value)
    //     setPageNo(1)
    // }
    // const handleSelectData = (data) => {
    //     setPerPage(data.value)
    //     setPageNo(1)
    // }
    ///////////

    const LoadData = (param, types) => {
        setIsLoading(true)
        setInsuranceTypeData([])
        if (types) {
            setSearchparamType(types)
        } else {
            setSearchparamType("")
        }
        const SearchPageNo = !param;
        ServerRequestProtected(API_URL + "/FindBySingleCriteria", 'post', {
            "TableName": enumUtil.enumAPITableName.InsuranceType,
            "SearchParam": param,
            "PerPage": PerPage,
            "PageNo": SearchPageNo ? PageNo : 1,
        }).then((response) => {
            setTotalCounts(response.Rows.length)
            setIsLoading(false)
            handleGridHeader({ defaultData: response.Rows })
            setInsuranceTypeData(response.Rows)
            setTotalPages(response.count.NumOfPages);
            if (type && type === "Wizard") {
                if (response.Rows?.length == 0 && isNull(searchParamType)) {
                    setisOpenInsuranceType(true)
                }
            }
        }).catch((error) => {
            setTotalCounts(0)
            setIsLoading(false)
            if (type && type === "Wizard") {
                if (InsuranceTypeData?.length == 0 && isNull(searchParamType)) {
                    setisOpenInsuranceType(true)
                }
            }
        })
    }

    const SearchByParam = () => {
        if (!isNull(searchParam)) {
            // setPageNo('1')
            LoadData(searchParam)
        } else {
            LoadData()
        }
    }
    const SearchOnEnter = (e) => {
        if (e.key === "Enter") {
            SearchByParam(searchParam, "searchParam")
        }
    }

    useEffect(() => {
        LoadData(searchParam);
    }, [PerPage, PageNo, isClose])
    const AddDiagnosis = (ID) => {
        setisOpenInsuranceType(true)
        setInsuranceTypeCode(ID)
    }
    const CloseDiagnosis = () => {
        setisOpenInsuranceType(false)
    }

    const DeleteDiagnosis = () => {
        setisOpenInsuranceType(false)
        setIsClose((Math.random()));
    }
    const handleRowSelection = (row) => {
        // console.log(row);
    }
    const handleCopy = (row, type) => {
        let name = `${row}-${type}`;
        console.log("Name", name)
        handleCopyText(type);
        setCopiedText({ ...copiedText, [name]: true });
        setTimeout(() => {
            setCopiedText({ ...copiedText, [name]: false });
        }, 300)
    }
    const columns = [

        {
            key: 'InsuranceTypeCode',
            width: 150,
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Insurance Type Code'} sortIcon={true} type={'string'} colKey={'InsuranceTypeCode'} data={InsuranceTypeData} setData={setInsuranceTypeData} />),
            width: 150,
            renderCell: ({ row }) => {
                return (
                    <button className="btn btn-link w-100 p-0" >
                        <div className="d-flex copy_icon_hover justify-content-between w-100 align-items-center copy_icon gap-1">
                            <div className="validation_message" onClick={() => AddDiagnosis(row.InsuranceTypeCodeID)}>{row.InsuranceTypeCode} </div>
                            <div className="icon_copy">
                                <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row.InsuranceTypeCodeID, row.InsuranceTypeCode)}></i>
                                <p class="tool_tip xsm_text text-light">Copy</p>
                            </div>
                            {copiedText[`${row.InsuranceTypeCodeID}-${row.InsuranceTypeCode}`] ? <p className={`xsm_text copied_text d-block`} >Copied to clipboard</p> : <></>}
                        </div>
                    </button>
                );
            },
        },
        {
            key: 'Description',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Description'} sortIcon={true} type={'string'} colKey={'Description'} data={InsuranceTypeData} setData={setInsuranceTypeData} />),
            resizable: true,
            renderCell: ({ row }) => {
                return (
                    <>
                        <div className="align-items-center pri_ins copy_icon copy_icon_hover d-flex gap-1 justify-content-between patient_col w-100">
                            {row.Description}
                        </div>
                    </>
                );
            }
        },
        {
            key: 'FullDescription',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Full Description'} sortIcon={true} type={'string'} colKey={'FullDescription'} data={InsuranceTypeData} setData={setInsuranceTypeData} />),
            resizable: true,
            renderCell: ({ row }) => {
                return (
                    <>
                        <div className="align-items-center pri_ins copy_icon copy_icon_hover d-flex gap-1 justify-content-between patient_col w-100">
                            <div className="copy_icon validation_message">
                                {row.FullDescription}
                            </div>
                            <div className="icon_copy">
                                <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row.InsuranceTypeCodeID, row.FullDescription)}></i>
                                <p class="tool_tip xsm_text text-light">Copy</p>
                            </div>
                            {copiedText[`${row.InsuranceTypeCodeID}-${row.FullDescription}`] ? <p className={`xsm_text copied_text d-block`} >Copied to clipboard</p> : <></>}
                        </div>
                    </>
                );
            }
        },
        {
            key: 'UpdatedBy',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Updated By'} sortIcon={true} type={'string'} colKey={'UpdatedBy'} data={InsuranceTypeData} setData={setInsuranceTypeData} />),
            resizable: true,
        },
        {
            key: 'UpdatedDate',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Updated Date'} sortIcon={true} type={'string'} colKey={'UpdatedDate'} data={InsuranceTypeData} setData={setInsuranceTypeData} />),
            resizable: true,
            renderCell: ({ row }) => {
                return (
                    <>
                        <div className="align-items-center pri_ins copy_icon copy_icon_hover d-flex gap-1 justify-content-between patient_col w-100">
                            {row.UpdatedDate}
                        </div>
                    </>
                );
            }
        },
    ]
    let PopupScreen = "";
    if (isOpenInsuranceType) {
        PopupScreen = <AddNewInsuranceTypeCode isOpenInsuranceType={isOpenInsuranceType} onClose={CloseDiagnosis} onDeleteDiagnosis={DeleteDiagnosis} InsuranceTypeCode={InsuranceTypeCode} type={type} />
    }
    const CloseMasterList = (ID) => {
        setisOpenMasterList(false)
        // setPOSCode(ID) 
    }
    let PopupScreenMasterList = "";
    if (isOpenMasterList) {
        PopupScreenMasterList = <MasterList isOpen={isOpenMasterList} onClose={CloseMasterList} LoadData={LoadData} GridTableName={'MasterListInsuranceType'} SaveTableName={'MasterListInsuranceType'} type={type} Name={"InsuranceType"} IsEditAllowed={IsEditAllowed}/>
    }
    const CardView = () => setShow(true);
    const TableView = () => setShow(false);
    const handleMasterList = () => {
        console.log('Here');
        setisOpenMasterList(true)
    };
    const rowClass = () => { return "row-bg" }
    const handleExcel = () => { }
    const handlePdf = () => { }
    const handleFilter = () => { }
    const handleDelete = () => { }
    const handleClearSearch = () => {
        setSearchParam('')
    }
    const InsuranceTypeBody = () => {
        return (
            <>
                <div className={show ? 'container-fluid action-row br-bottom-1 br-clr' : 'container-fluid action-row br-clr'}>
                    <div className="row justify-content-between">
                        <div className="col-4">
                            <div className="input">
                                <div className='input-group hk-input-search'>
                                    <input type="text" className='form-control fc-xs'
                                        placeholder='Search by name or id…'
                                        onChange={e => setSearchParam(e.target.value)}
                                        onKeyDown={SearchOnEnter} value={searchParam} />
                                    {searchParam?.length > 0 ?
                                        <span className="input-group-text" id="basic-addon2" onClick={handleClearSearch}>
                                            <i className="bi bi-x"></i>
                                        </span> : <span className="input-group-text" id="basic-addon2" onClick={SearchByParam}>
                                            <i className="bi bi-search"></i>
                                        </span>}
                                </div>
                            </div>
                        </div>
                        <div className="col-8 ps-0">
                            <SearchHeader
                                AddNew={AddDiagnosis}
                                Excel={handleExcel}
                                PDF={handlePdf}
                                masterListButton={handleMasterList}
                                showRecentRecordButton={false}
                                Delete={handleDelete}
                                Filter={handleFilter}
                                cardView={CardView}
                                tableView={TableView}
                                show={show}
                                searchButton={searchButton}
                                Key={622}
                                Name={'Insurance Type'}
                                Counts={totalCounts}
                            />
                        </div>
                    </div>
                </div>
                {show ?
                    <Card
                        AddNew={AddDiagnosis}
                        Data={InsuranceTypeData}
                        API_URL={API_URL}
                        TableName={enumUtil.enumAPITableName.InsuranceType}
                        DeleteDiagnosis={DeleteDiagnosis}
                        Key={622}
                        Name={'Insurance Type'}
                    />
                    : (
                        <Table
                            columns={columns}
                            rows={InsuranceTypeData}
                            height='500px'
                            rowClass={rowClass}
                            // dynamicClass= 'fill-grid DataGrid-Table hk-exp-table'
                            dynamicClass='fill-grid DataGrid-Table hk-exp-table insurance_table'
                            rowHeight={25}
                            PerPage={PerPage}
                            PageNo={PageNo}
                            TotalPages={TotalPages}
                            handlePageClick={handlePageClick}
                            PreviousPage={PreviousPage}
                            handleFingByCreteria={handleFingByCreteria}
                            NextPage={NextPage}
                            Key={622}
                            Name={'Insurance Type'}
                            isLoading={isLoading}
                            TableName={'InsuranceType'}
                            handleSelectData={handleSelectData}
                            LoadData={() => LoadData(searchParam)}
                             ClearSearch={handleClearSearch}
                        />
                    )
                }
            </>
        )
    }
    // useEffect(()=>{
    //     if(type && type === "Wizard"){
    //         if(InsuranceTypeData?.length == 0 && isNull(searchParamType)){
    //             setisOpenInsuranceType(true)
    //         }
    //     }
    // },[InsuranceTypeData, searchParamType])
    return (
        <React.Fragment>
            {/* {PopupScreen} */}
            {isLoading ? <Loader /> : null}
            {type && type === "Wizard" ?
                <>
                    {/* {InsuranceTypeData?.length > 0 || !isNull(searchParamType) ? */}
                    <>
                        {isOpenInsuranceType ? <>{PopupScreen}</> : isOpenMasterList ? <>{PopupScreenMasterList}</> : <>{InsuranceTypeBody()}</>}
                        {/* {isOpenInsuranceType ? <>{PopupScreen}</> : <>{InsuranceTypeBody()}</>} */}
                    </>
                    {/* : <>{PopupScreen}</> */}
                    {/* } */}
                </> :
                <>
                    {PopupScreen}
                    {PopupScreenMasterList}
                    {InsuranceTypeBody()}
                </>
            }

        </React.Fragment>
    )
}
const mapStateToProps = (state) => {
    return {
        Settings: state.SettingsReducer
    }
}
export default connect(mapStateToProps)(InsuranceTypeCode)